// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueCookies from 'vue-cookies'
import VueClipboard from 'vue-clipboard2'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import XEUtils from 'xe-utils'
import VXETable from 'vxe-table'
import 'vxe-table/lib/index.css'
import Contextmenu from 'vue-contextmenujs'
import Print from 'vue-print-nb'
import FcDesigner from '@form-create/designer'
import ActionForm from './components/widgets/ActionForm'
import FilePreview from './components/widgets/FilePreview'
import ImageViewer from './components/widgets/ImageViewer'
import Ellipsis from './components/elements/flow/common/Ellipsis'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import {Base64} from 'js-base64'
import '../static/css/fc-font.css'
import '../static/css/iconfont.css'
import routeConfig from './constants/routeConfig'
import routeUtils from './util/routeUtils'
import pathUtils from './util/pathUtils'
import {debounce} from 'throttle-debounce'

Vue.config.productionTip = false
/* 兼容旧版 Popconfirm 事件名（新版 confirm -> 旧版 onConfirm），需在 Vue.use 之前修改 */
const Popconfirm = ElementUI.Popconfirm
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.confirm) {
  const originalConfirm = Popconfirm.methods.confirm
  Popconfirm.methods.confirm = function () {
    this.$emit('onConfirm')
    originalConfirm.call(this)
  }
}
if (Popconfirm && Popconfirm.methods && Popconfirm.methods.cancel) {
  const originalCancel = Popconfirm.methods.cancel
  Popconfirm.methods.cancel = function () {
    this.$emit('onCancel')
    originalCancel.call(this)
  }
}
/* 引入cookie工具 */
Vue.use(VueCookies)
/* 引入复制功能 */
Vue.use(VueClipboard)
/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, { size: 'small', zIndex: 3000 })
/* 引入vxe-table */
Vue.use(VXETable)
/* 右键菜单 */
Vue.use(Contextmenu)
/* 打印支持 */
Vue.use(Print)
// 使用 form-create 和 designer
Vue.use(FcDesigner)
Vue.use(FcDesigner.formCreate)
/* 注册全局组件 */
Vue.component('action-form', ActionForm)
Vue.component('file-preview', FilePreview)
/* 省略号组件 */
Vue.use(Ellipsis)

/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  return new Promise((resolve, reject) => {
    let requestUrl = config.url
    if (requestUrl && requestUrl.startsWith('/')) {
      config.url = pathUtils.getContextPath(requestUrl)
    }
    store.dispatch('globalRequestHeaders', config.url).then(val => {
      if (val) {
        Object.keys(val).forEach(key => {
          config.headers.common[key] = val[key]
        })
      }
      resolve(config)
    }).catch(err => {
      reject(err)
    })
  })
})

/* 非法请求预处理 */
const invalidMessageBox = debounce(500, status => {
  const accountObj = store.state.account
  if (accountObj && accountObj.loginId) {
    switch (status) {
      case 401: {
        ElementUI.MessageBox.alert('您当前的会话已经失效，请点击按钮重新登录', '提示', {
          center: true,
          confirmButtonText: '重新登录',
          callback: () => {
            window.location.href = pathUtils.getHomePath()
          }
        })
        return true
      }
      default:
        break
    }
  } else {
    switch (status) {
      case 401: {
        window.location.href = pathUtils.getHomePath()
        return true
      }
      case 403: {
        ElementUI.MessageBox.alert('您没有访问当前页面的权限，请点确定返回首页', '提示', {
          center: true,
          confirmButtonText: '确定',
          callback: () => {
            window.location.href = pathUtils.getHomePath()
          }
        })
        return true
      }
      default:
        break
    }
  }
})

/* 跳转错误页 */
const toErrorPage = (router, path, query) => {
  if (routeUtils.canMatchRoute(router, path)) {
    router.replace({ path: path, query: query })
  }
}

$axios.interceptors.response.use(response => {
  return response
}, error => {
  Vue.nextTick(() => {
    if (error.response && error.response.config) {
      // 状态预处理
      if (invalidMessageBox(error.response.status)) {
        return
      }
      let instance = error.response.config.instance
      if (instance && !error.response.config['disableErrorPage']) {
        let currentRoute = router.currentRoute
        let instanceParentPath = routeUtils.getInstanceParentPath(instance, currentRoute)
        if (typeof instanceParentPath === 'string') {
          let matchId = routeUtils.getParentRouteMatchId(instance, currentRoute)
          switch (error.response.status) {
            case 403: {
              toErrorPage(router, instanceParentPath + '/error/403', { redirect: currentRoute.path, [routeConfig.Redirect.id]: matchId })
              break
            }
            case 404: {
              toErrorPage(router, instanceParentPath + '/error/404', { redirect: currentRoute.path, [routeConfig.Redirect.id]: matchId })
              break
            }
            case 500: {
              toErrorPage(router, instanceParentPath + '/error/500', { redirect: currentRoute.path, [routeConfig.Redirect.id]: matchId })
              break
            }
            default: {
              toErrorPage(router, instanceParentPath + '/error/unknown', { redirect: currentRoute.path, [routeConfig.Redirect.id]: matchId, errCode: error.response.status })
              break
            }
          }
        }
      }
    }
  })
  return Promise.reject(error)
})

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = function (config) {
  config.instance = this
  return $axios(config)
}
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$base64 = Base64
Vue.prototype.$extend = function () {
  return Object.assign({}, ...arguments)
}
Vue.prototype.$contextPath = pathUtils.getContextPath
Vue.prototype.$isNotEmpty = obj => {
  return obj !== undefined && obj !== null && obj !== '' && obj !== 'null'
}
Vue.prototype.$deepCopy = obj => {
  return XEUtils.clone(obj, true)
}
Vue.prototype.$previewImage = (urlList, initialIndex = 0, zIndex = 9999) => {
  const Constructor = Vue.extend(ImageViewer)
  const instance = new Constructor({
    propsData: { urlList, initialIndex, zIndex }
  })
  const vm = instance.$mount()
  document.body.appendChild(vm.$el)
  const remove = () => {
    document.body.removeChild(vm.$el)
    vm.$destroy()
  }
  vm.$on('close', remove)
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
